// extracted by mini-css-extract-plugin
export default {"automationBtn":"grouppolicyStyle_automationBtn__z0wcf","tableHead":"grouppolicyStyle_tableHead__Oi29w","progressBar":"grouppolicyStyle_progressBar__rjULE"};